import SDModal from '@/shared/components/SDComponentsNewDesign/SDModal/SDModal'

import useLocationModal from './useLocationModal'
import LocationForm from './LocationForm/LocationForm'

const LocationModal = () => {
  const { isOpen, title, onOpenChange } = useLocationModal()

  return <SDModal isOpen={isOpen} openHandler={onOpenChange} title={title} sections={<LocationForm />} />
}

export default LocationModal
